import { getColorClassName, getColorStyle } from '../facets/Color';
/**
 * Returns background's classname depending on background type
 * @param backgroundType {string} - BackgroundType
 * @returns {string} - Background Color value
 */
export const getBackgroundClassName = (backgroundType) => {
    return `background-${getColorClassName(backgroundType)}`;
};
/**
 * Returns background's style depending on background type
 * @param backgroundType {string} - BackgroundType
 * @returns {string} - Background Color value
 */
export const getBackgroundStyle = (backgroundType) => {
    return getColorStyle(backgroundType);
};
//# sourceMappingURL=Background.js.map